var React = require('react');

function AppBeacon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10 19c-4.97 0-9-4.03-9-9s4.03-9 9-9 9 4.03 9 9-4.03 9-9 9zm0-1c4.42 0 8-3.58 8-8s-3.58-8-8-8-8 3.58-8 8 3.58 8 8 8zm3-9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM7 9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm3 5c.38 0 .75-.05 1.1-.16.36-.1.7-.25 1-.44.3-.2.6-.43.83-.7.25-.28.46-.6.63-.93l.9.46c-.2.42-.48.8-.8 1.14-.3.35-.65.64-1.04.88-.38.24-.8.42-1.24.55-.45.13-.9.2-1.38.2-.48 0-.94-.07-1.38-.2-.45-.13-.86-.3-1.24-.55-.4-.24-.74-.53-1.05-.88-.3-.34-.58-.72-.8-1.14l.9-.46c.18.34.4.65.64.93.24.27.52.5.83.7.3.2.64.34 1 .44.34.1.7.16 1.1.16z","fillRule":"evenodd"}));
}

AppBeacon.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = AppBeacon;

AppBeacon.default = AppBeacon;
